import store from '@/store';
import router from '..';
import {
  LOGIN_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  DASHBOARD_ROUTE,
  ERROR_ROUTE,
} from '@/router/routes';
import {
  CLEAR_ERRORMSG,
  UPDATE_ROUTER_LOADER,
} from '@/store/action_types';
import { resetLoaders } from '@/utils/loaders';
import { RouteLocationNormalized } from 'vue-router';

export const ifNotAuthDeny = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: Function
) => {
  store.dispatch(UPDATE_ROUTER_LOADER, true);

  console.log('fromm', from)

  try {
    // clear error messages
    store.dispatch(CLEAR_ERRORMSG);

    // clear isLoading states
    resetLoaders();

    if (
      store.getters.sessionToken == null ||
      store.getters.account.data == null
    ) {
      router.push({ name: LOGIN_ROUTE });
      return;
    }

    // if (
    //   store.getters.account.data &&
    //   !store.getters.account.data.isEmailVerified
    // ) {
    //   if (to.name !== EMAIL_VERIFICATION_WALL_ROUTE) {
    //     return router.replace({ name: EMAIL_VERIFICATION_WALL_ROUTE });
    //   }
    // }

    // if (!store.getters.organizationActiveSubscription.data) {
    //   // If organizationActiveSubscription data is null, allow access to SUBSCRIPTION_WALL_ROUTE
    //   if (to.name !== SUBSCRIPTION_WALL_ROUTE) {
    //     console.log('Redirecting to SUBSCRIPTION_WALL_ROUTE');
    //     return next({ name: SUBSCRIPTION_WALL_ROUTE });
    //   }
    // } else {
    //   // If organizationActiveSubscription data is not null, prevent access to SUBSCRIPTION_WALL_ROUTE
    //   if (to.name === SUBSCRIPTION_WALL_ROUTE) {
    //     console.log('Redirecting to DASHBOARD_ROUTE');
    //     return next({ name: DASHBOARD_ROUTE });
    //   } else {
    //     return next();
    //   }
    // }

    // Allow navigation if none of the above conditions are met
    next();
  } finally {
    // Ensure the loader is turned off on function exit
    // store.dispatch(UPDATE_ROUTER_LOADER, false);
  }
};
